import { RequestMainService } from "../request";

export class CategoryService {
  static async getList(params: any = {}) {
    return RequestMainService.get(`/admin/genres`, params).then(
      ({ result }) => {
        return {
          count: result?.total,
          data: result.genres,
        };
      }
    );
  }

  static async import(params: any) {
    return RequestMainService.uploadFile(`/admin/genres/import`, params).then(
      (res) => res?.data
    );
  }

  static async delete(id: string | number) {
    return RequestMainService.delete(`/admin/genres/${id}`);
  }
}
